export const DEFAULT_INFO_SIZE = 5;
export const DEFAULT_INFO_PAGE = 0;
